/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import * as IconFactory from 'app/components/common/IconFactory.jsx';

class LoginComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            creds: {
                username: '',
                password: ''
            }
        }

        this.checkChar = this.checkChar.bind(this);
        this.loginUser = this.loginUser.bind(this);
        this.onSocialLogin = this.onSocialLogin.bind(this);

    }

    checkChar(e) {

        if (e.charCode === 13) {
            this.loginUser();
        }

    }

    loginUser() {

        this.props.loginUser(this.state.creds.username, this.state.creds.password);

    }

    onSocialLogin(e) {

        e.preventDefault();

        this.props.socialLogin(e.currentTarget.dataset.svc);

    }

    render() {
        let constants = this.props.app.config.constants;

        return (
            <div className="dlvr-login-block">
                <div className="q-post-login-header">
                    <h2>Sign in and share</h2>
                    <div className="alert alert-error">
                        {this.props.loginErrors}
                    </div>
                </div>
                <fieldset>
                    <div className="sign-in-field">
                        <input type="text" name="username" className="text-input medium" placeholder="Email Address" defaultValue={this.state.username} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="creds.username" onKeyPress={this.checkChar}/>
                    </div>
                    <div className="sign-in-field">
                        <input type="password" name="password" className="text-input medium" placeholder="Password" defaultValue={this.state.password} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="creds.password" onKeyPress={this.checkChar}/>
                    </div>
                </fieldset>
                <div className="q-post-login-social clearfix">
                    <div className="q-social-login twitter" onClick={this.onSocialLogin} data-svc={constants.LOGIN_SVC_TWITTER} role="button" aria-label="sign in with twitter">
                        <IconFactory.twitter/>
                        <span className="">Sign in with Twitter</span>
                    </div>
                    <div className="q-social-login google" onClick={this.onSocialLogin} data-svc={constants.LOGIN_SVC_GOOGLE} role="button" aria-label="sign in with google">
                        <IconFactory.google/>
                        <span className="">Sign in with Google</span>
                    </div>

                    <div className="q-social-login facebook" onClick={this.onSocialLogin} data-svc={constants.LOGIN_SVC_FACEBOOK} role="button" aria-label="sign in with facebook">
                        <IconFactory.facebook/>
                        <span className="">Sign in with Facebook</span>
                    </div>
                </div>
                <fieldset>
                    <input type="button" className="btn-primary fixed active" value="sign in" onClick={this.loginUser} onKeyPress={this.checkChar}/>
                </fieldset>
                <div className="new-account">
                    <a href={this.props.app.config.signupUrl} target="_blank">Need an account? Create one!</a>
                </div>
            </div>
        );
    }

};

LoginComponent.propTypes = {
    loginUser: PropTypes.func,
    socialLogin: PropTypes.func,
    loginErrors: PropTypes.string
};

LoginComponent.defaultProps = {
    loginUser: () => {},
    socialLogin: () => {},
    loginErrors: ''
};

export default LoginComponent;
